export default "__VITE_ASSET__DDevokPC__"